<div mat-dialog-title>
  <h2>Stimulus</h2>
  <eiq-button
    testId="stimulus-preview-close"
    [title]="'Close stimulus preview dialog'"
    [color]="'light'"
    [style]="'icon'"
    [icon]="faClose"
    class="mat-dialog-title__close"
    (clicked)="onCancel()"
  ></eiq-button>
</div>
<div mat-dialog-content>
  <div class="stimulus-preview-dialog__file">
    <span class="fs__lg fw__500">{{ data.name }}</span>
    @if (data.type === fileType.VideoMp4) {
      <video data-testid="stimulus-preview-video" controls>
        <source [src]="data.url" />
      </video>
    } @else if (data.type === fileType.AudioMp3) {
      <audio data-testid="stimulus-preview-audio" controls>
        <source [src]="data.url" />
      </audio>
    } @else if (imageTypes.includes(data.type)) {
      <img [alt]="data.name" [src]="data.url" />
    }
  </div>
</div>
<div mat-dialog-actions>
  <button data-testid="stimulus-preview-cancel-button" mat-stroked-button (click)="onCancel()">Close</button>
</div>
